import { render, staticRenderFns } from "./Matters.vue?vue&type=template&id=8c7a7742"
import script from "./Matters.vue?vue&type=script&lang=js"
export * from "./Matters.vue?vue&type=script&lang=js"
import style0 from "./Matters.vue?vue&type=style&index=0&id=8c7a7742&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports